import { isArray } from "lodash";

import { IFilterItem, IFilterItemApi, ReplaceFilterField } from "../../types/filters";
import { IOrdering } from "../../types/pagination";
import { camelToSnakeCase } from "../../utils/transformCase";

const replaceFieldName = (name: string, replaceFields: ReplaceFilterField[]): string => {
  replaceFields.forEach(({ from, to }) => {
    if (name === from) {
      name = to;
    }
  });
  return name;
};

export const adaptFilterItemsForBe = (
  filterItems: IFilterItem[],
  replaceFields: ReplaceFilterField[] = []
): IFilterItemApi[] => {
  return filterItems
    .filter((filter) => {
      const isEmptyArray = isArray(filter.value) && filter.value.length === 0;
      const isEmptyString = filter.value === "";

      return !isEmptyString && !isEmptyArray;
    })
    .map((filter) => {
      const name = replaceFieldName(filter.name, replaceFields);

      return {
        name: camelToSnakeCase(name),
        operator: filter.operator,
        value: filter.value,
      };
    });
};

export const adaptOrderingForBe = (ordering: IOrdering, replaceFields: ReplaceFilterField[] = []): IOrdering => {
  const orderBy = replaceFieldName(ordering.orderBy, replaceFields);

  return {
    orderBy: camelToSnakeCase(orderBy),
    descending: ordering.descending,
  };
};
